import React, { useEffect, useState, forwardRef } from 'react';
import styled from '@emotion/styled';
import fieldStyles from 'components/Field/styles.sass';
import { FieldController } from 'shared/FieldController';
import { FieldHexProps, HexInputProps } from './types';

const Container = styled.div`
  position: relative;
  display: flex;
`;

const Pound = styled.span`
  position: absolute;
  top: 13px;
  left: 16px;
  font-size: 1rem;
`;

const Input = styled.input`
  height: 46px;
  padding: 0 43px 0 24px;
  font-size: 1rem;
  text-transform: uppercase;
`;

const ColorPreview = styled.div<{
  backgroundColor: string;
}>`
  position: absolute;
  top: 11px;
  right: 11px;
  width: 24px;
  height: 24px;
  border: 1px solid #dfe0e1;
  border-radius: 4px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

const isValidHexValue = (value: string): boolean => hexRegex.test(value);

/**
 * @deprecated Use Anchor-ds's FieldHex instead
 * https://sites.spotify.net/s/%40spotify-internal-anchor-ds/?path=/story/encore-forms-overview--page
 */
export const FieldHex = forwardRef(
  (
    { name, value, containerClassName, ...rest }: HexInputProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const [isValidHex, setIsValidHex] = useState(false);
    const [hexValue, setHexValue] = useState(`#${value}`);
    useEffect(() => {
      setIsValidHex(isValidHexValue(hexValue));
    }, [hexValue]);
    useEffect(() => {
      setHexValue(`#${value}`);
    }, [value]);
    return (
      <Container className={containerClassName}>
        <Pound>#</Pound>
        <Input
          ref={ref}
          {...rest}
          type="text"
          value={value}
          className={fieldStyles.input}
          data-cy={name}
        />
        <ColorPreview backgroundColor={isValidHex ? hexValue : 'transparent'} />
      </Container>
    );
  }
);

export const ControlledFieldHex = (props: FieldHexProps) => (
  <FieldController<HexInputProps, HTMLInputElement> as={FieldHex} {...props} />
);
